import { useEffect, useState } from 'react'
import { getRembleArticles } from '../../common/api/Articles'
import ArticleListItem from '../ArticleListItem'
import { Container } from 'react-bootstrap'
import { ROUTE_ARTICLES_ALL } from '../../common/helpers/Paths'
import Loading from 'templates/Loading'

// Initialize the intersection observer
const _previewObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    // Default to a blank image
    let imageSrc = entry.target.getAttribute('src') || ''

    // Show the thumbnail preview
    if (entry.isIntersecting)
      imageSrc = entry.target.querySelector('.article-image img') || imageSrc

    // Update the image src
    entry.target.src = imageSrc
  })
})

const sortArticles = (a, b) => new Date(b['published-on']) - new Date(a['published-on'])

/**
 * Simple article List component. Used to display articles title and preview
 */
export default function ArticlesList({ cache, count = 0, sort = false, returnPath = null }) {
  const [loading, setLoading] = useState(true)
  const [articles, setArticles] = useState([])

  useEffect(() => {
    async function getRembleArticlesAsync() {
      let articles = await cache.tryGetAsyncResult(
        ROUTE_ARTICLES_ALL,
        getRembleArticles,
        this
      )
      if (sort) {
        articles = articles.sort(sortArticles)
      }

      if (count > 0) {
        articles = articles.slice(0, count)
      }

      setArticles(articles)
      setLoading(false)
    }

    getRembleArticlesAsync()
  }, [cache, setLoading, sort, count])

  return (
    <Loading isLoaded={loading}>
      <Container className='articles-container mt-md-5'>
        {articles &&
          articles.map(article => (
            <ArticleListItem
              article={article}
              key={article.id}
              observer={_previewObserver}
              returnPath={returnPath}
            />
          ))}
      </Container>
    </Loading>
  )
}
